import useHistory from './useHistory';

export default function useWidgetId () {
  const { location: { queryParams } } = useHistory();
  const match = window.location.pathname.match(/^\/widget\/([^/]+)/);
  const widgetId = match ? match[1] : (queryParams && queryParams.widget);
  return widgetId || null;
}
